// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".unset-border-right[data-v-3237af19]  input{border-bottom-right-radius:0;border-top-right-radius:0}.border-state[data-v-3237af19]  .input-group-text{border-color:red!important}", ""]);
// Exports
module.exports = exports;
